import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { DtoExport } from '@core/utils/dto';
import { UpdateDeliveryOrderRequestSchema } from './update-delivery-order-request.schema';

export class UpdateDeliveryOrderRequest {
    public pickupAtReady?: string;
    public dropoffAddress?: string;
    public managerNote?: string;

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: UpdateDeliveryOrderRequestSchema,
        },
    ])
    export(type?: DtoType): any {}
}